import { getCollectors } from '@/api/collector';
import { useEffect, useState } from 'react';
import { DateRange } from 'react-day-picker';

interface MetaData {
  total: number;
  lastPage: number;
  currentPage: number;
  perPage: number;
  prev: number | null;
  next: number | null;
}

interface ClientResponse {
  data: Collector[];
  meta: MetaData;
}

export const useCollectors = (
  page: number,
  perPage: number,
  searchTerm: string,
  selectedWilaya: string,
  status: string,
  selectedCollector: string,
  dateRange: DateRange | undefined
) => {
  const [collectors, setCollectors] = useState<Collector[]>([]);
  const [meta, setMeta] = useState<MetaData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCollectors = async () => {
    setLoading(true);
    try {
      const response: ClientResponse = await getCollectors({
        page,
        perPage,
        searchTerm,
        selectedWilaya,
        status,
        selectedCollector,
        dateRange,
      });
      setCollectors(response.data);
      setMeta(response.meta);
      console.log('response :', response);
    } catch (err) {
      setError('Failed to fetch collectors');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollectors();
  }, [
    page,
    perPage,
    searchTerm,
    selectedWilaya,
    status,
    dateRange,
    selectedCollector,
  ]);

  const refresh = () => {
    fetchCollectors();
  };

  return { collectors, refresh, meta, loading, error };
};
